import { render } from "./CinemasEdit.vue?vue&type=template&id=2faa9d37&scoped=true"
import script from "./CinemasEdit.vue?vue&type=script&lang=js"
export * from "./CinemasEdit.vue?vue&type=script&lang=js"

import "./CinemasEdit.vue?vue&type=style&index=0&id=2faa9d37&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faa9d37"]])

export default __exports__